import { Component, Input, OnInit } from '@angular/core';
import { IconRegistryService } from '../../services/icon-registry.service';
import { SafeHtml } from '@angular/platform-browser';
import { IconName } from '../../models/icon-name.type';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [AsyncPipe, NgClass],
  templateUrl: './icon.component.html'
})
export class IconComponent implements OnInit {

  @Input({ required: true }) name!: IconName;

  // Tailwind classes support
  @Input() class = '';

  svg$!: any;

  constructor(private iconRegistry: IconRegistryService) {}

  ngOnInit() {
    this.svg$ = this.iconRegistry.getIcon(this.name);
  }
}
